import { createContext, useContext } from "react";
import axios from "axios";

const FeedbackContext = createContext();

export const FeedbackProvider = ({ children }) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // const sendFeedback = async (payload) => {
  //   try {
  //     const res = await axios.post(`${BASE_URL}/api/feedback`, payload);
  //     return res.data;
  //   } catch (err) {
  //     console.error("Feedback failed:", err);
  //     throw err;
  //   }
  // };
  const sendFeedback = async (payload, files) => {
    const formData = new FormData();
    formData.append("firstName", payload.firstName);
    formData.append("lastName", payload.lastName);
    formData.append("email", payload.email);
    formData.append("description", payload.description);

    if (files) {
      files.forEach((file) => formData.append("files", file));
    }

    const res = await axios.post(`${BASE_URL}/api/feedback`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  };
  return (
    <FeedbackContext.Provider value={{ sendFeedback }}>
      {children}
    </FeedbackContext.Provider>
  );
};

export const useFeedback = () => useContext(FeedbackContext);
